var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41414 7.40065V12.2163C9.41414 12.8971 8.88038 13.4491 8.21072 13.4491H2.99779C2.32673 13.4491 1.79297 12.8971 1.79297 12.2163V4.81926C1.79488 4.49288 1.92538 4.18042 2.15617 3.94963C2.38696 3.71884 2.69943 3.58834 3.0258 3.58643H5.66295C5.75423 3.58656 5.84457 3.60487 5.92871 3.64027C6.01284 3.67568 6.08909 3.72748 6.15301 3.79265L9.21128 6.90276C9.3414 7.03581 9.41422 7.21455 9.41414 7.40065Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60352 3.58643V6.61248C5.60599 6.81978 5.68944 7.0179 5.83603 7.16449C5.98263 7.31109 6.18074 7.39454 6.38805 7.39701H9.4141",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93164 3.58643V2.12944C4.93355 1.80306 5.06405 1.4906 5.29484 1.25981C5.52563 1.02902 5.8381 0.898518 6.16448 0.896606H8.79826C8.89004 0.896734 8.98089 0.915021 9.06558 0.950414C9.15026 0.985806 9.2271 1.03761 9.29168 1.10283L12.35 4.21294C12.48 4.34459 12.5528 4.52217 12.5528 4.70719V9.52646C12.5528 10.2073 12.019 10.7593 11.3494 10.7593H9.63883",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74219 0.896606V3.92266C8.74466 4.12996 8.82811 4.32808 8.97471 4.47467C9.1213 4.62127 9.31942 4.70472 9.52672 4.70719H12.5528",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDocument);
export default __webpack_public_path__ + "static/media/TotalDocument.5c0bacc28e04c0ee6a9245641af21380.svg";
export { ForwardRef as ReactComponent };